import React from "react";
import Navbar from "./Navbar";


function Core() {

    return ( 

        <body id ="core-page">
                <Navbar/>
            <div className= "core--container">
            <h1 className ="core--title">CORE</h1>
            <p className ="core--dialogue1">chasing the mayfly called meaning</p>
            </div>

        </body>
    )
}
export default Core;